import { FeatureFlags, config } from "./config";

import React, { createContext, useCallback, useContext, useMemo } from "react";
import { useOptionalUser } from "./OS/Login/State";
import { useFragment, graphql } from "react-relay";
import { useHasFeatureFlag_store$key } from "./__generated__/useHasFeatureFlag_store.graphql";

const StoreFeatureFlagContext = createContext({
  hasFeature: (feature: FeatureFlags): boolean => false,
});

export function useHasFeatureFlag(feature: FeatureFlags) {
  const ctx = useContext(StoreFeatureFlagContext);

  const hasFeature = useMemo(() => ctx.hasFeature(feature), [ctx, feature]);

  return hasFeature;
}

export const StoreFeatureFlagProvider = (props: {
  store: useHasFeatureFlag_store$key | null;
  children: React.ReactNode;
}) => {
  if (props.store) {
    return <StoreFeatureFlagProviderC {...props} store={props.store} />;
  }

  return <>{props.children}</>;
};

const StoreFeatureFlagProviderC = (props: {
  store: useHasFeatureFlag_store$key;
  children: React.ReactNode;
}) => {
  const user = useOptionalUser();

  const store = useFragment(
    graphql`
      fragment useHasFeatureFlag_store on Store {
        id
        flags
      }
    `,
    props.store
  );

  const hasFeature = useCallback(
    (flag: FeatureFlags) => {
      return config.hasFeature(
        flag,
        store.id?.replace("SPS_", "") ?? "",
        user?.user.sub,
        store.flags ?? []
      );
    },
    [store.flags, store.id, user?.user.sub]
  );

  const val = useMemo(() => ({ hasFeature }), [hasFeature]);
  return (
    <StoreFeatureFlagContext.Provider value={val}>
      {props.children}
    </StoreFeatureFlagContext.Provider>
  );
};
export function useIsStoresprintAdmin() {
  const user = useOptionalUser();

  return user?.user.email?.endsWith("@storesprint.app") ?? false;
}
